<template>
	<popper
		:trigger="trigger"
		:force-show="forceShow"
		:tagName="tagName"
		:options="{
			placement,
			modifiers: {
				flip: {
					enabled: false,
				},
				preventOverflow: {
					escapeWithReference: true,
				},
			},
		}"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<div class="popper">
			<span v-if="tooltip">{{ tooltip }}</span>
			<slot name="tooltip" />
		</div>

		<slot slot="reference" />
	</popper>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
export default {
	components: {
		popper: Popper,
	},
	inheritAttrs: false,
	props: {
		tooltip: String,
		placement: {
			type: String,
			default() {
				return 'top';
			},
		},
		trigger: {
			type: String,
			default() {
				return 'hover';
			},
		},
		forceShow: {
			type: Boolean,
			default() {
				return false;
			},
		},
		tagName: {
			type: String,
			default: 'span',
		},
	},
};
</script>
